<template>
<sidebar-widget
    :start-expanded="startExpanded"
    :sections="sections"
    :headers="['Contribution Band', 'Employer Matches']"
>
    <template v-slot:title>Match Tiers</template>

    <template v-slot:headerbutton>
        <button type="button" class="btn btn-outline-primary" @click.prevent="$emit('edit')">
            <i class="far fa-pen" aria-hidden="true" title="Edit"></i>
            Edit
        </button>
    </template>

    <template v-slot:row-details="props">
        <div>
            <span>Employee Contribution: </span> <span>{{ props.row.employee_contribution }}%</span><br />
            <span>Employer Match: </span> <span>{{ props.row.employer_match }}%</span><br />
        </div>
    </template>
</sidebar-widget>

</template>

<script>
import SidebarWidget from './SidebarWidget'

export default {
    props: ['plan', 'startExpanded', ],
    components: {SidebarWidget, },
    emits: ['edit', ],
    computed: {
        sections() {
            const rows = []

            // NB: the tiers are incremental bands consumed in priority order, so the
            // first row reads "the first N%" and every later one "the next N%". The API
            // returns them already ordered by priority.
            this.plan.match_tiers.forEach((mt, idx) => {
                rows.push({
                    employee_contribution: mt.employee_contribution,
                    employer_match: mt.employer_match,
                    cells: [
                        `${idx == 0 ? 'First' : 'Next'} ${mt.employee_contribution}%`,
                        `${mt.employer_match}%`,
                    ],
                    id: mt.id,
                })
            })

            return [{title: 'Main', rows: rows}]
        },
    },
}
</script>
